import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export default function StickyMobileCTA() {
  return (
    <div data-testid="sticky-mobile-cta" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-charcoal/95 backdrop-blur-lg border-t border-cream/10 px-3 py-3 grid grid-cols-3 gap-2">
      <a href={BUSINESS.doordash} target="_blank" rel="noreferrer" data-testid="sticky-order" className="bg-terracotta text-cream text-center text-xs font-medium py-3 rounded-full active:scale-95 transition-transform">Order</a>
      <button onClick={() => scrollToId("catering")} data-testid="sticky-catering" className="border border-cream/30 text-cream text-xs py-3 rounded-full active:scale-95 transition-transform">Catering</button>
      <a href={BUSINESS.phoneHref} data-testid="sticky-call" className="border border-cream/30 text-cream text-xs py-3 rounded-full flex items-center justify-center gap-1 active:scale-95 transition-transform"><Phone size={13} /> Call</a>
    </div>
  );
}
